<template>
  <v-main class="d-flex align-center justify-center h-screen">
    <v-card width="550" class="pa-4">
      <v-card-title class="screen-title">ワンタイムURL発行確認</v-card-title>
      <v-card-text class="pt-4"> ワンタイムURLを送信しました。 </v-card-text>
    </v-card>
  </v-main>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "OneTimeUrlIssueComplete",
});
</script>
